module.exports = __webpack_public_path__ + "img/turbo_on.45c55a3b.png";